import React from 'react'
import BottomLine from '../../../../components/BottomLine/BottomLine';
import './timesheetdetails.css'
import { Divider } from 'antd';

const TotalDetails = (props) => {
   return (
      <div className='timesheet-total-details-container-parent'>
         {<div className='timesheet-total-details-container'>
            <div className='total-work-hours-row'>
               <div>
                  Total worked hours
               </div>
               <div>
                  38 hrs / 40 hrs
               </div>
            </div>
            <div className='total-work-hours-row'>
               <div>
                  Overtime
               </div>
               <div>1 hrs</div>
            </div>
            <div className='total-work-hours-row'>
               <div>Absent time</div>
               <div>{props.TotalAbsent && props.TotalAbsent +" hrs"}</div>
            </div>
         </div>
         }
         <Divider />
         <div className='total-bill-row'>
            <div className='bill-amount'>Bill amount calculated</div>
            <div className='bill-amount-value'>$ {props.BillAmountCalculated? props.BillAmountCalculated:null}</div>
         </div>
      </div>
   )
}
export default TotalDetails;